import { useTranslation } from 'react-i18next';
import {
  CardPocket,
  TCardPocketValueProps,
} from '@/common/components/CardPocket/CardPocket';
import { Icon } from '@/common/components/Icons/Icon';
import { ROUTES } from '@/common/constants/routes';
import { useGetPockets } from '@/common/integrations/menhir/employee/pockets/pockets.hooks';
import { useGetWelfareBalance } from '@/common/integrations/menhir/employee/welfare/welfare.hooks';
import { MoneyUtils, removeFalsey } from '@coverflex-tech/hypernova-utils';
import { useRouter } from 'expo-router';

export function ITWelfareCardPocket() {
  const { welfare, isInitialLoading: isLoadingWelfare } =
    useGetWelfareBalance();
  const { t } = useTranslation();
  const router = useRouter();
  const { fringePocket, isInitialLoading: isLoadingFringe } = useGetPockets();

  const values = [
    {
      label: t('dashboard.welfare.balance.description'),
      value: MoneyUtils.moneyToString(welfare?.availableBalance),
      loading: isLoadingWelfare,
    },
    fringePocket && {
      label: t('dashboard.fringe.balance.description'),
      value: MoneyUtils.moneyToString(fringePocket?.balance),
      type: 'secondary',
      loading: isLoadingFringe,
    },
  ].filter(removeFalsey) as TCardPocketValueProps[];

  return (
    <CardPocket
      title="Welfare"
      icon={<Icon icon="seedling" />}
      values={values}
      onPress={() => router.push(ROUTES.WELFARE)}
    />
  );
}
